import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import {strVal} from '../../../../modules/Utils'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import {Link} from 'react-router-dom'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import QuotesApi from '../../../../api/Sales/Quotes'
import {isEmpty} from 'lodash'
import DateCell from '../../../../elements/Table/Cells/DateCell'

LinesHistory.propTypes = {}
const columns = [
  {
    Header: 'Code',
    accessor: 'quote.code',
    Cell: ({original, value}) => (
      <Link
        to={{
          pathname: `/clients/quotes/${original.quote._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({value, original}) => value || strVal(original, 'product.name'),
  },
  {
    Header: 'Date',
    accessor: 'createDate',
    Cell: DateCell,
  },
  {
    Header: 'Product',
    accessor: 'product.name',
    hideable: true,
    hideDefault: false,
  },
  {
    Header: 'Category',
    accessor: 'product.category.name',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Group',
    accessor: 'product.group.name',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Quantity',
    accessor: 'unit',
    Cell: MoneyCell,
  },
  {
    Header: 'Rate',
    accessor: 'rate',
    Cell: MoneyCell,
  },
  {
    Header: 'Total',
    accessor: 'amount.net',
    Cell: MoneyCell,
    Footer: SumFooter,
  },
]
const api = new QuotesApi()

function LinesHistory(props) {
  const {line} = props
  const {fetch, fetching, list} = useFetchList(
    () => api.lines.clientHistory(line._key),
    [line._rev],
    isEmpty(line._key),
  )

  return (
    <CustomTable
      columns={columns}
      data={list}
      fetching={fetching}
      fetch={fetch}
    />
  )
}

export default LinesHistory
